import type { FC } from 'react';

import type { IconProps } from './type';

export const FeaturedIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height={16}
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.601 15.098c-1.03 0-2.002-.2-2.915-.598a7.442 7.442 0 0 1-2.39-1.598 7.441 7.441 0 0 1-1.598-2.389 7.217 7.217 0 0 1-.597-2.915c0-1.03.2-2.003.597-2.916.387-.913.92-1.71 1.599-2.389A7.441 7.441 0 0 1 4.686.695 7.217 7.217 0 0 1 7.6.098c1.03 0 2.003.199 2.916.597a7.44 7.44 0 0 1 2.389 1.598 7.44 7.44 0 0 1 1.598 2.389c.398.913.597 1.885.597 2.916 0 1.03-.199 2.002-.597 2.915a7.44 7.44 0 0 1-1.598 2.39 7.442 7.442 0 0 1-2.39 1.598 7.218 7.218 0 0 1-2.915.597Zm-1.88-9.749L3.86 7.23l3.741 3.741 3.741-3.741-1.861-1.88H5.72Z"
        fill="#B4BAE9"
      />
    </svg>
  );
};
